"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericContentServiceV2 = void 0;
const operators_1 = require("rxjs/operators");
const http_1 = require("@angular/common/http");
const rxjs_1 = require("rxjs");
const constants = require("../../shared/constants");
/**
 * Generic Content Service
 *
 * Class used for retreaving Generic Content and Basic HTML items
 */
class GenericContentServiceV2 {
    constructor(http) {
        this.http = http;
    }
    getGenericContent(id) {
        return this.http.get(constants.genericContentUrl + id).pipe(operators_1.map((res) => res), operators_1.catchError((error) => {
            throw error.message;
        }));
    }
    getBulkGenericContent(ids) {
        return this.http.post(constants.genericContentBulkUrl, ids).pipe(operators_1.map((res) => res), operators_1.catchError((error) => {
            throw error.message;
        }));
    }
}
exports.GenericContentServiceV2 = GenericContentServiceV2;
//# sourceMappingURL=generic-content.service.js.map